export default __webpack_public_path__ + "static/media/cu.ec766d1d.png";